module.exports = __webpack_public_path__ + "img/img-bottom@2x.a57dcacd.png";